<template>
  <div class="download-box" :class="dataObj.appClassName">
    <div class="download-content">
      <div class="todownload">
        <img v-if="dataObj.logo" :src="dataObj.logo" alt />
        <p>{{ dataObj.appName }}</p>
      </div>
      <div class="download-app">
        <div class="software-list">
          <!-- 苹果版本下载 -->
          <div class="software" v-if="dataObj.appStoreUrl && isIos">
            <a :href="dataObj.appStoreUrl">
              <img src="../assets/app-store.png" alt />
              <span></span>
              {{ dataObj.appName == 'FitDao' && userLang == 'en' ? 'Download for Apple phone' : $t('code.appStoreDown')
              }}
            </a>
          </div>
          <!-- 谷歌版本下载 -->
          <div class="software" v-if="!isTimezoneOffset && dataObj.googlePlayUrl && !isIos">
            <a :href="dataObj.googlePlayUrl">
              <img :src="require(`../assets/google-play.png`)" alt />
              <span></span>
              {{ dataObj.appName == 'FitDao' && userLang == 'en' ? 'Download for Android phone' :
                $t('code.googlePlayDown')
              }}
            </a>
          </div>
          <!-- 安卓版本下载(国内) -->
          <div class="software" v-if="isTimezoneOffset && dataObj.chinaAppUrl && !isIos">
            <a :href="'#'" @click.prevent="androidDownload(dataObj.chinaAppUrl)">
              <img :src="require(`../assets/android-inland.png`)" alt />
              <span></span>
              {{ dataObj.appName == 'FitDao' && userLang == 'en' ? 'Download for Android phone' : $t('code.androidDown')
              }}
            </a>
          </div>
          <!-- 华为版本下载 -->
          <div class="software" v-if="!isTimezoneOffset && dataObj.huaweiStoreUrl">
            <a :href="dataObj.huaweiStoreUrl">
              <img :src="require(`../assets/huawei.png`)" alt />
              <span></span>
              {{ $t('code.huaweiDown') }}
            </a>
          </div>
        </div>
      </div>
      <div class="load" v-if="loading">
        <van-loading type="spinner" />
      </div>
    </div>
    <div class="stratum" v-if="isStratum">
      <div class="stratum-message">
        <div class="message-content">
          <div class="c-text">
            <img src="../assets/stratum-icon.png" alt />
            {{ $t('code.stratumMessage') }}
          </div>
          <div class="c-btn">
            <span class="btn" @click="confirm()">{{ $t('code.iKnow') }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <van-dialog v-model="isDialog" :title="$t('code.installationNotice')" show-cancel-button @confirm="confirmDialog()"
      :confirm-button-text="$t('code.update')" :cancel-button-text="$t('code.cancel')">
      <p>{{ textDialog.after }}{{ textDialog.before }}</p>
    </van-dialog>
  </div>
</template>

<script>
import { getMarkingDetail } from "@/api/app.js";
import brand_model_map from "@/utils/brand_model_map.json";
export default {
  data() {
    return {
      key: "",
      loading: false,
      dataObj: {},
      appStoreUrl: "",
      googlePlayUrl: "",
      isTimezoneOffset: false, //是否在东8区
      imageUrl: "img/assets/bg.png",
      isStratum: false, //是否显示遮罩层
      isIos: false, //是否是ios系统
      isDialog: false, //是否显示弹窗
      textDialog: {},
      userLang: ''
    };
  },
  methods: {
    //  新的方法
    toDownload() {


      var u = navigator.userAgent;
      var ua = u.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.isIos = true;
        // iOS 系统 ->  跳AppStore下载地址
        this.getMarkingDetail(this.key, (res) => {
          res.appStoreUrl && (window.location.href = res.appStoreUrl);
        });
      } else if (/android/.test(ua)) {
        this.isIos = false;
        // 安卓系统 -> 跳安卓端下载地址

        // 获取安卓端下载地址
        this.getMarkingDetail(this.key);

      } else if (this.IsPC()) {
        // PC端
        this.getMarkingDetail(this.key);
      }
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    // 获取跳转地址
    getMarkingDetail(marking, callback) {
      this.loading = true;
      let data = {
        marking,
      };
      getMarkingDetail(data).then((response) => {
        this.loading = false;
        if (!response.data) {
          this.$toast.fail(this.$t('code.noData'));
          return;
        }
        // 渲染背景图片

        this.dataObj = response.data;
        this.dataObj.appClassName = this.dataObj.appName
          .toLowerCase()
          .replace(/\s+/g, "-");
        callback && callback(response.data);
      });
    },
    // 确认（知道了）按钮
    confirm() {
      this.isStratum = false;
    },
    // 设备型号判断
    detectBrand() {
      let u = navigator.userAgent;
      let ua = u.toLowerCase();
      // 小米 & 华为设备型号（可持续扩展）
      const brandModelMap = brand_model_map;
      const modelStr = ua.replace(/\s+/g, '');

      for (const model of brandModelMap.xiaomi) {
        if (modelStr.includes(model.toLowerCase())) return 'xiaomi';
      }

      for (const model of brandModelMap.huawei) {
        if (modelStr.includes(model.toLowerCase())) return 'huawei';
      }

      return 'other';
    },
    confirmDialog() {
      window.location.href = this.dataObj.chinaAppUrl;
    },
    androidDownload() {
      // 检测手机品牌如果为小米或华为，则显示弹窗
      if (this.isTimezoneOffset) {
        let brand = this.detectBrand();
        // let brand = "xiaomi";
        switch (brand) {
          case 'xiaomi':
          case 'redmi':
            this.isDialog = true;
            this.textDialog.after = this.$t('code.xiaomiDownTips.after');
            this.textDialog.before = this.$t('code.xiaomiDownTips.before');

            break;
          case 'huawei':
            this.isDialog = true;
            this.textDialog.after = this.$t('code.huaweiDownTips.after');
            this.textDialog.before = this.$t('code.huaweiDownTips.before');
            break;

          default:
            this.isDialog = false;
            this.confirmDialog();
            break;
        }


      }
    },
    getBrowserLanguage() {
      return (navigator.languages && navigator.languages.length)
        ? navigator.languages[0]
        : navigator.language || navigator.userLanguage || 'en'; // 设置一个默认语言（如英文）
    }
  },
  mounted() {
    this.key = this.$route.params.key;
    // this.isTimezoneOffset = new Date().getTimezoneOffset() == -480; // 获取当前时区,在东8区会显示-480
    //国际化语言切换
    // this.$i18n.locale = this.isTimezoneOffset ? "zh" : "en";

    let userLang = this.getBrowserLanguage();

    switch (userLang.toLowerCase()) {
      case 'zh-cn':
        this.$i18n.locale = "zh";
        this.isTimezoneOffset = true;
        break;
      case 'zh-hk':
      case 'zh-tw':
        this.$i18n.locale = "zh-hk";
        this.isTimezoneOffset = false;
        break;

      default:
        this.$i18n.locale = "en";
        userLang = "en";
        this.isTimezoneOffset = false;
        break;
    }

    this.userLang = userLang;

    this.toDownload();

    // 判断是否在安卓手机上的微信浏览器中
    const isAndroidWechat =
      /Android/i.test(navigator.userAgent) &&
      /MicroMessenger/i.test(navigator.userAgent);

    if (isAndroidWechat) {
      this.isStratum = true;
    } else {
      this.isStratum = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.load {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

p {
  color: #1b1b2e;
  font-size: 60px;
}

.todownload {
  text-align: center;

  img {
    margin-top: 100px;
    width: 200px;
  }
}

.download-box {
  position: relative;

  .stratum {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.4);

    .stratum-message {
      position: absolute;
      right: 16px;
      top: 36px;

      .message-content {
        color: #3f3f3f;
        width: 488px;
        height: 208px;
        background-color: #fff;
        border-radius: 32px;
        padding: 32px;
        box-sizing: border-box;
        font-size: 30px;

        .c-text {
          display: flex;
          align-items: center;

          img {
            width: 32px;
            padding-right: 10px;
          }
        }

        .c-btn {
          padding-top: 32px;
          text-align: right;

          .btn {
            border: 1px solid #364389;
            color: #364389;
            border-radius: 32px;
            padding: 9px 22px;
            font-size: 30px;
            display: inline-block;
          }
        }

        &::after {
          content: "";
          position: absolute;
          right: 32px;
          top: -14px;

          border-left: transparent 14px solid;
          border-right: transparent 14px solid;
          border-bottom: #fff 16px solid;
        }
      }
    }
  }

  display: flex;
  justify-content: center;
  background: url("../assets/bg.png") no-repeat center center;

  &.fitbeing {
    background-image: url("../assets/fitbeing.png");
  }

  &.cubitt-pro {
    background-image: url("../assets/cubitt_pro.png");
  }

  background-size: cover;
  height: 100%;
}

.download-content {
  padding-top: 342px;
  width: 750px;

  .todownload {
    img {
      width: 200px;
      display: block;
      margin: 0 auto;
    }

    p {
      text-align: center;
      font-size: 52px;
      margin: 20px 0;
      font-weight: bold;
    }
  }

  .download-app {
    position: absolute;
    bottom: 84px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding-top: 80px;

    .software-list {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      width: 100%;
      padding: 0 32px;
      box-sizing: border-box;

      .software {
        height: 100px;
        background-color: #fff;
        width: 100%;
        margin: 16px 0;
        border-radius: 50px;

        .software-box {
          display: flex;
          align-items: center;
          justify-items: center;
        }

        a {
          text-align: center;
          color: #1b1b2e;
          font-size: 32px;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;

          img {
            width: 48px;
            border-radius: 10px;
            padding-right: 10px;
          }

          span {
            padding-top: 10px;
            padding-bottom: 10px;
            font-size: 20px;
            color: #3f3f3f;
          }
        }
      }
    }
  }
}

// 弹窗样式修改
::v-deep .van-dialog {
  border-radius: 80px;
  // padding: 0 40px;

  .van-dialog__header {
    color: #333;
    padding-top: 40px;
  }

  .van-dialog__content {
    padding: 0 50px 5px 50px;

    p {
      font-size: 30px;
      line-height: 60px;
    }
  }

  .van-dialog__footer {

    margin: 10px 20px 40px;
    border: none;

    .van-button {
      border-radius: 50px;
      margin: 0 20px;
      background-color: #eaeef6;
      font-size: 30px;
      color: #000;

      &::after {
        border: none;
      }

    }

    &::after {
      border: none;
    }


  }
}
</style>